import { memo } from "react";

import { QuestionConnection as Question } from "@/components/features/items/edit/_shared/ui/components/main/questions/connection";

import { QuestionPlanRequiredOptionCombinedConnection } from "./components";
import { usePlanAvailableOptionIDs } from "./hooks";

export const QuestionPlanOptionConnection = memo(() => {
	const { availableItemIDs, rawAvailableItemIDs, nameAndIDOptions, onSetAvailableItemIDs } =
		usePlanAvailableOptionIDs();

	const title = "予約可能なオプション";
	const guide =
		"このプランで予約可能なオプションを選択しましょう。<br />※一覧には公開中のオプションと、このプランに紐づけ済みのオプションを表示します。紐づけ済みで非公開のものは先頭に【非公開】と付きます。";

	return (
		<>
			<Question
				title={title}
				guide={guide}
				availableItemIDs={availableItemIDs}
				rawAvailableItemIDs={rawAvailableItemIDs}
				nameAndIDOptions={nameAndIDOptions}
				onSetAvailableItemIDs={onSetAvailableItemIDs}
			/>
			<QuestionPlanRequiredOptionCombinedConnection />
		</>
	);
});

QuestionPlanOptionConnection.displayName = "QuestionPlanOptionConnection";
